export const WORKSPACE_CHANGED = "socialcheck:workspace-changed";

// Only successful content mutations invalidate read-only navigation counters.
export function notifyWorkspaceMutation(response) {
  const method = String(response?.config?.method || "get").toLowerCase();
  const path = String(response?.config?.url || "").split("?")[0];
  if (!["post", "patch", "put", "delete"].includes(method) || !(response?.status >= 200 && response?.status < 300)) return;
  if (!/^\/(?:cockpit\/posts|posts|approvals|photo-jobs|tasks|beitraege|tenants\/[^/]+\/posts)(?:\/|$)/.test(path)) return;
  if (typeof window !== "undefined") window.dispatchEvent(new Event(WORKSPACE_CHANGED));
}
